$(function () {
  SvgSprite();

  $(document).ready(function() {});
});
